// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3g2ia","emails":"CreateEditClinics_emails__33QW4","emailTagLabel":"CreateEditClinics_emailTagLabel__3H8o2"};